<template>
  <Navbar />
  <div class="page-container">
    <a-spin v-if="isRedirecting" class="loading-spinner" />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import Navbar from "../components/Navbar.vue";

const router = useRouter();
const isRedirecting = ref(true);

// 2026-08-06：CheckEmail (CheckInbox) 改為重導到 /phone-validate
//   - 保留路由避免舊信件中的連結失效
//   - 若使用者已登入且需要補綁手機，導向 /bind-mobile
onMounted(() => {
  const token = localStorage.getItem("ms_platform_token");
  if (token) {
    router.replace("/bind-mobile");
  } else {
    router.replace("/phone-validate");
  }
});
</script>

<style scoped>
.page-container {
  min-height: 60vh;
  background-color: var(--color-primary-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-spinner {
  font-size: 24px;
}
</style>
